import { IApplicationState } from '../../../../../../types/types';
import { getNavigationPanelState } from './getNavigationPanelState';
import { ENavigationPanelWidths } from '../../constants';

export const getNavigationPanelWidthSelector = (
    state: IApplicationState
): number => {
    const panelType = getNavigationPanelState(state).panelType
    return ENavigationPanelWidths[panelType];
};
